module.exports = __webpack_public_path__ + "img/f45c7f9.jpg";